// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3Ccod","noInteraction":"EventWrapper_noInteraction__3C5W7","pointerPassthrough":"EventWrapper_pointerPassthrough__3YiA3"};